import { render, staticRenderFns } from "./CheckVoucherComponent.vue?vue&type=template&id=2b74631e"
import script from "./CheckVoucherComponent.vue?vue&type=script&lang=js"
export * from "./CheckVoucherComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports